'use es6';

import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { createTracker } from 'usage-tracker-public';
import { setApiClient } from 'marketplace-assets-base/clients/apiClient';
import { setEcosystemApiBase } from 'marketplace-assets-base/clients/ecosystemClient';
import { PUBLIC } from 'marketplace-assets-base/constants/AppContext';
import { getPublicRootUrl } from 'marketplace-assets-base/utils/urls';
import { getUsageTrackerConfig, setUsageTracker } from 'marketplace-assets-base/utils/usageTracker';
import BaseApp from 'marketplace-assets-base/App';
import AppContainer from './AppContainer';
import rhumbConfig from '../rhumb-config.yaml';
let userEmailPromise;

function maybeGetUserEmail() {
  if (!userEmailPromise) {
    // TODO check early request
    const response = noAuthApiClient.get('/login-verify/echo/user');
    userEmailPromise = response.then(user => user.email);
  }

  return userEmailPromise;
}

export default class App extends BaseApp {
  initialize() {
    setEcosystemApiBase('ecosystem/public/v1');
    setApiClient(noAuthApiClient);
    this.setUsageTracker();
    const langAvailable = this.setupI18n();
    return langAvailable;
  }

  setupI18n() {
    const i18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    i18nProvider.setLocale({
      locale: this.getLang(),
      langEnabled: true
    });
    return this.registerI18n(i18nProvider);
  }

  setUsageTracker() {
    const usageTrackerConfig = getUsageTrackerConfig({
      inAppOrPublic: 'public'
    });
    usageTrackerConfig.isExternalHost = false;
    usageTrackerConfig.properties = Object.assign({}, usageTrackerConfig.properties, {
      email: () => maybeGetUserEmail().catch(() => null)
    });
    setUsageTracker(createTracker(usageTrackerConfig));
  }

  getAppContext() {
    return PUBLIC;
  }

  getAppName() {
    return 'marketplace-assets-public-ui';
  }

  getAppComponent() {
    return AppContainer;
  }

  getLang() {
    return window.I18N_MANUAL_LANG || 'en';
  }

  getRootUrl() {
    return getPublicRootUrl(this.getLang());
  }

  getRhumbConfig() {
    return rhumbConfig;
  }

  renderFeedbackLoader() {
    return null;
  }

}